<script lang="ts" setup>
import { Toaster as Sonner, type ToasterProps } from "vue-sonner";

const props = defineProps<ToasterProps>();
</script>

<template>
  <Sonner
    class="toaster group fixed-width"
    v-bind="props"
    :toast-options="{
      classes: {
        toast: 'group toast rounded-md group-[.toaster]:shadow-lg',
        description: 'group-[.toast]:text-muted-foreground',
        actionButton:
          'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
        cancelButton:
          'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
      },
    }" />
</template>
<style scoped>
.fixed-width {
  width: 300px; /* Adjust the width as needed */
}

/*
 * vue-sonner defaults the close button to the top-LEFT corner. Move it to the
 * top-right and make it (and its icon) a bit bigger. These rules target the
 * button directly with !important so they win over vue-sonner's own
 * runtime-injected stylesheet regardless of injection order.
 */
:deep([data-close-button]) {
  left: auto !important;
  right: 0 !important;
  transform: translate(35%, -35%) !important;
  width: 24px;
  height: 24px;
}

:deep([data-close-button] svg) {
  width: 16px;
  height: 16px;
}
</style>
